import { UserInvitationForm } from 'components/forms/user-invitation-form/user-invitation-form';
import { useCallback } from 'react';
import { closeModal } from 'store/modals/modals.slice';
import { removeUserFromStore } from 'store/users/users.slice';
import { getUsersThunk } from 'store/users/users.thunks';

import { MODAL_USER } from '../../../shared/constants/modals';
import { useAppDispatch, useAppSelector } from '../../../store';
import { Modal } from '../../template/modals/modal';

export const UserModal = () => {
  const dispatch = useAppDispatch();

  const modal = useAppSelector((state) =>
    state.modals.find((modal) => modal.name === MODAL_USER),
  );
  const isDirty = useAppSelector((state) => state.formIsDirty.isDirty);

  const page =
    typeof modal?.data === 'object' && modal.data?.page ? modal.data.page : 0;

  const handleClose = useCallback(() => {
    dispatch(closeModal({ name: MODAL_USER }));
    dispatch(removeUserFromStore());
    dispatch(getUsersThunk(page));
  }, [dispatch, page]);

  if (!modal || !modal.isOpen) {
    return null;
  }

  return (
    <Modal formIsDirty={isDirty} close={handleClose}>
      <UserInvitationForm page={page} />
    </Modal>
  );
};
